export default __webpack_public_path__ + "static/media/shoppingBag.5cfb5c36.svg";